var coucouSlide, coucouSlideshow;

coucouSlideshow = function () {
  return $(".coucou-slideshow").each(function () {
    var $this;
    $this = $(this);
    if ($this.children("li").length > 1) {
      return setTimeout(function () {
        return coucouSlide($this);
      }, 7000);
    }
  });
};

coucouSlide = function (element) {
  var $current, $next;
  if (element.is(":visible")) {
    $current = element.children("li.active");
    if ($current.is(":last-child")) {
      $next = element.children("li:first-child");
    } else {
      $next = $current.next();
    }
    return $next.imagesLoaded(function () {
      $current.removeClass("active");
      $next.addClass("active");
      return setTimeout(function () {
        return coucouSlide(element);
      }, 6000);
    });
  }
};

$(document).on("page:load", coucouSlideshow);

$(function () {
  return coucouSlideshow();
});

// ---
// generated by coffee-script 1.9.2
